<template>

    <div class="templates screenshotss">
        <h1>{{ $t("templates.title") }}</h1>

        <div class="buttoms-section">
            <button class="btn btn-register" @click="openTemplateModal">
                {{ $t("diagnostic.templates.register") }}
            </button>
        </div>

        <v-client-table
            v-if="listTemplates"
            :columns="table_options.columns"
            :options="table_options.options"
            :data="listTemplates">
            <!-- Actions -->
            <template v-slot:top="props">
            <div class="starred">
                <i v-if="props.row.top" class="fas fa-star"></i>
            </div>
            </template>
            <template v-slot:createdAt="props">
            {{ props.row.createdAt | formatDate(appLang) }}
            </template>
            <template v-slot:actions="props">
            <div class="actions">
                <!-- Edit -->
                <i class="far far fa-edit" @click="onClick('edit',props.row)"></i>
                <!-- Delete -->
                <i class="far fa-trash-alt" @click="onClick('delete',props.row)"></i>
            </div>
            </template>
        </v-client-table>

        <!-- MODAL CREAR / EDITAR -->
        <Modal v-if="showTemplateModal" @closeModal="closeTemplateModal">
            <!-- HEADER -->
            <template #header>
                <h6 class="modal-title bolded">
                {{ $t("diagnostic.templates.modal.title") }}
                </h6>
            </template>

            <!-- BODY -->
            <template>
                <div class="bg-white p-3 row item-details">
                <div class="col-md-12">

                    <div v-if="errorMessage" class="alert alert-danger mb-3">
                    {{ errorMessage }}
                    </div>

                    <label
                    v-if="modalMode === 'update'"
                    class="mt-4 bolded"
                    >
                    {{ $t("diagnostic.templates.modal.id") }}
                    </label>

                    <input
                    v-if="modalMode === 'update'"
                    type="text"
                    v-model="idTemplate"
                    disabled
                    />

                    <label class="bolded">
                    {{ $t("diagnostic.templates.modal.name") }}
                    </label>

                    <input
                    type="text"
                    v-model="nameTemplate"
                    required
                    />
                </div>
                </div>
            </template>

            <!-- FOOTER -->
            <template #footer>
                <div class="controls">
                <button
                    class="btn btn-cancel"
                    @click="closeTemplateModal"
                >
                    Cancelar
                </button>

                <button
                    class="btn btn-save"
                    @click="createTemplate"
                >
                    Guardar
                </button>
                </div>
            </template>
        </Modal>

        <!-- MODAL DELETE -->
        <Modal v-if="modalActive" @closeModal="closeModal">
            <!-- HEADER -->
            <template #header>
                <h6 v-if="deleteModal" class="modal-title">
                    {{ $t("surveys.modal.deleteTemplateTitle") }}
                </h6>
            </template>

            <!-- BODY -->
            <template>
                <div v-if="error">
                    <b-alert v-model="error" variant="danger" dismissible id="alert-modal">
                        Es necesario llenar todos los campos!
                    </b-alert>
                </div>

                <div v-if="deleteModal">
                    <p>{{ $t("surveys.modal.deleteTemplate") }}</p>
                </div>
            </template>

            <!-- FOOTER -->
            <template #footer>
                <div v-if="deleteModal" class="controls">
                    <span class="control cancel-btn" @click="closeModal">
                        {{ $t("surveys.modal.cancel") }}
                    </span>

                    <button type="button" class="btn-save" :disabled="isLoading" @click="deleteSurvey(surveyId)">
                        {{ $t("surveys.modal.deleteButton") }}
                    </button>
                </div>
            </template>
        </Modal>

    </div>
</template>

<script>
import API_SERVICES from "@/lib/api/Diagnostic.js";
import moment from "moment";
import momentTimezone from 'moment-timezone';
const Modal = () => import("@/components/Modal");
const api_diagnostic = new API_SERVICES();

export default {
    components: {
        Modal
    },
    props: ["values", "onChange"],
    data() {
        return {
            modalActive: false,
            surveys: [],
            newModal: false,
            showTemplateModal: false,
            deleteModal: false,
            renameModal: false,
            surveyObj: null,
            surveyId: "",
            templateId: "",
            select: "",
            name: "",
            rename: "",
            nameTemplate: "",
            infoTemplate: {},
            isLoading: false,
            active: false,
            error: false,
            surveyType: "",
            listTemplates:[],
            table_options: {
                columns: [
                "id",
                "name",
                "actions"
                ],
                options: {
                headings: {
                    id: "ID",
                    name: "Nombre",
                    actions: "Acciones"
                },
                sortable: ["id", "name"],
                filterable: ["id", "name"],
                perPage: 10,
                perPageValues: [5, 10, 20]
                }
            }
        };
    },

    beforeMount: async function () {
        await this.getTemplates();
    },

    methods: {
        openTemplateModal: function() {
            this.errorMessage = '';
            this.modalMode = 'create';
            this.showTemplateModal = true;
        },
        openEditTemplateModal: function() {
            this.errorMessage = '';
            this.modalMode = 'update';
            this.showTemplateModal = true;
        },
        closeTemplateModal: function() {
            this.showTemplateModal = false;
        },
        dateFormat: function (date) {
            return moment(date).locale(this.$i18n.locale).format("LL");
        },
        openDeleteModal: function (id) {
            this.modalActive = true;
            this.deleteModal = true;
            this.newModal = false;
            this.renameModal = false;
            this.surveyId = id;
        },
        openRenameModal: function (object) {
            this.modalActive = true;
            this.renameModal = true;
            this.newModal = false;
            this.deleteModal = false;
            this.rename = object.name;
            this.surveyObj = object;
        },
        closeModal: function () {
            this.modalActive = false;
            this.deleteModal = false;
        },
        validateForm: function (item) {
            if (!this.select || !this.name) {
                this.error = true;
            } else {
                try {
                    this.error = false;
                    this.createSurvey();
                } catch (error) {
                    throw error;
                }
            }
        },
        validateEdit: function () {
            if (this.rename === "") {
                this.error = true;
            } else {
                try {
                    this.error = false;
                    this.editSurvey();
                } catch (error) {
                }
            }
        },
        getTemplates:async function () {
            this.$store.commit("global/SET_LOADING", true);
            try {

                const resp = await api_diagnostic.getTemplates();

                const sorted = [...resp.items].sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );

                this.listTemplates = sorted;

                this.$store.commit("global/SET_LOADING", false);
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }
        },
        createTemplate: async function () {
            let dateFrom = momentTimezone().tz('America/Mexico_City').format('YYYY-MM-DD HH:mm')
            let dateTo = momentTimezone().tz('America/Mexico_City').format('YYYY-MM-DD HH:mm')

            console.log("Begin: ",this.nameTemplate);
            console.log("Name: ",this.name);
            this.$store.commit("global/SET_LOADING", true);
            
            try {
                
                let params = {
                    name: this.nameTemplate,
                    details: "-",
                    points: 0,
                    isActive: true,
                    isPublished: false,
                    estimatedTime: 1,
                };
                const resp = await api_diagnostic.createSurvey(params);
                this.closeTemplateModal();
                this.$store.commit("global/SET_LOADING", false);
                const id = resp.id;

                const temporal = {
                            "id": id,
                            "surveyObj": {
                                "name": this.nameTemplate,
                                "details": "-",
                                "points": 0,
                                "id": id,
                                "validFrom": dateFrom,
                                "validTo": dateTo,
                                "surveyType":"type"
                            },
                            "typeAccion":"create",
                            "typeTemplate":"normal",
                            "firstTime": true,
                            "surveyType": "multipleOptionSurvey"
                        };
                        
                this.$router.push(
                {
                    name: 'Edit Template',
                    params: { 
                        id: id,
                        mode: 'new'
                    }
                });

            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }
            this.$store.commit("global/SET_LOADING", false);
        },
        deleteSurvey: async function(id) {
            this.$store.commit("global/SET_LOADING", true);
            console.log('Template ID:: ',this.templateId);
            try {
                const respTemp = await api_diagnostic.deleteTemplate(this.templateId);
                await this.getTemplates();
                this.closeModal();
                this.$store.commit("global/SET_LOADING", false);
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }
        },
        onClick: async function(action, row) {
            this.$store.commit("global/SET_LOADING", true);

            this.templateId = row.id;
            console.log('Template ID: ', this.templateId);

            if (action == "delete") {
                this.modalActive = true;
                this.deleteModal = true;
                this.surveyId = 0;
                this.$store.commit("global/SET_LOADING", false);
                return;
            }

            if (action == "edit") {
                this.$store.commit("global/SET_LOADING", false);

                this.$router.push({
                    name: "Edit Template",
                    params: {
                        id: this.templateId,
                        mode: "edit",
                    },
                });
            }
        }
    },
    computed: {
        userRole() {
            return this.$store.getters["session/role"];
        }
    },
};
</script>

<style scoped>
.templates .buttoms-section {
  width: 60%;
  display: flex;
  align-items: center;
  margin-top: 2rem;
}
.templates .buttoms-section .btn-register {
  background-color: #000;
  color: #fff;
  border-radius: 0px;
  padding: 0.7rem 1.5rem;
  margin-bottom: 2rem;
}
.templates .buttoms-section .btn-register:hover {
  background-color: #000;
  border-color: #fff;
  color: #fff;
}
.error {
  color: #bb0a30;
}
.screenshotss {
min-width: 100%;
width: 100% !important;
}
.actions {
  display: flex;
  gap: 12px; /* ajusta el espacio */
}
.cancel-btn {
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  margin-left: 15px;
  color: #000;
  text-decoration: none;
}
.cancel-btn:hover {
  text-decoration: underline;
}
.btn-save {
  font-family: "audi-bold";
  color: #fff;
  background-color: #000;
  border-color: #000;
  padding: 10px 20px;
  border-radius: 0px;
  border: none;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  margin-left: 15px;

  &:hover {
    background-color: #bb0a30;
    border-color: #bb0a30;
  }
}
</style>